var lightbox = new SimpleLightbox(".gallery a", {
  /* options */
});
